var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataTableExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 12.4444V1.55556H1.55556V12.4444H12.4444ZM12.4444 0C12.857 0 13.2527 0.163888 13.5444 0.455612C13.8361 0.747335 14 1.143 14 1.55556V12.4444C14 12.857 13.8361 13.2527 13.5444 13.5444C13.2527 13.8361 12.857 14 12.4444 14H1.55556C1.143 14 0.747335 13.8361 0.455612 13.5444C0.163888 13.2527 0 12.857 0 12.4444V1.55556C0 0.692222 0.7 0 1.55556 0H12.4444ZM10.8889 6.22222V7.77778H3.11111V6.22222H10.8889Z",
    fill: "#266C87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 12.4444H12.4444V1.55556H1.55556V12.4444ZM14 12.4444C14 12.857 13.8361 13.2527 13.5444 13.5444C13.2527 13.8361 12.857 14 12.4444 14H1.55556C1.143 14 0.747335 13.8361 0.455612 13.5444C0.163888 13.2527 0 12.857 0 12.4444V1.55556C1.80335e-08 1.143 0.163889 0.747334 0.455612 0.455611C0.747335 0.163888 1.143 -1.80335e-08 1.55556 0H12.4444C13.3078 3.77375e-08 14 0.7 14 1.55556V12.4444ZM7.77778 10.8889H6.22222L6.22222 3.11111H7.77778L7.77778 10.8889Z",
    fill: "#266C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTableExpand);
export default __webpack_public_path__ + "static/media/data-table-expand.43895ed9ac44354437f80ac1f0ec292c.svg";
export { ForwardRef as ReactComponent };